// extracted by mini-css-extract-plugin
export default {"stats":"stats-UcvJrff2","stat":"stat-luTZoUR8"};